import { render, staticRenderFns } from "./OnboardingUpcomingDeparturePage.vue?vue&type=template&id=a9699872&scoped=true&"
import script from "./OnboardingUpcomingDeparturePage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUpcomingDeparturePage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingUpcomingDeparturePage.vue?vue&type=style&index=0&id=a9699872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9699872",
  null
  
)

export default component.exports